/**
 * Fever positions from https://gigpro.atlassian.net/browse/GOLD-3319
 */
export const extraPositions = new Set([
  "Event Coordinator",
  "Event Lead",
  "Event Staff",
  "Conversion Staff",
  "Uhaul Driver",
  "Host",
  "Wardrobe",
  "Assistant Team Lead",
]);

/**
 * World Cup account positions from https://gigpro.atlassian.net/browse/CORE-5564.
 * Gated behind the `world-cup-positions` LD flag (segment-targeted to World
 * Cup Organizations). Mirrors the `extraPositions` / `extra-positions` pattern
 * above — independent Set + flag so World Cup and Fever can be enabled
 * separately per org without polluting each other's segments.
 */
export const worldCupPositions = new Set(["Security Event Staff", "Parking Attendant"]);
